import { Alert } from 'react-bootstrap';

export const GlobalErrorAlert = (props : { errorMessage: Array<string | undefined> }) => {
  return (
    <Alert variant="danger">
      <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
      <p>Server responded with:</p>
        { props.errorMessage.map ((error, index) => {
          return error && <li key={index}>{error}</li>
        })
        }
    </Alert>
  );
};
